import {
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
  withStyles,
} from '@material-ui/core';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface HeaderProps {
  title: string;
  icon?: JSX.Element;
}

export interface FooterProps {
  title: string;
  icon?: JSX.Element;
  href: string;
}

export interface OwnProps {
  header?: HeaderProps | null;
  footer?: FooterProps | null;
  items: React.ReactNode | null;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

export const DropMenuItem = withStyles(theme => ({
  root: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightMedium,
    paddingTop: 10,
    paddingBottom: 10,

    '& svg': {
      marginLeft: 8,
    },
  },
}))(MenuItem);

export const DropNotificationItem = withStyles(() => ({
  root: {
    position: 'relative',
    fontSize: 12,
    paddingTop: 8,
    paddingBottom: 8,
    minHeight: 0,
    height: 'auto',
    whiteSpace: 'initial',

    '& svg': {
      position: 'absolute',
      bottom: 6,
      right: 16,
    },
  },
}))(props => (
  <MenuItem {...props}>
    {props.children}
    <TrendingFlatIcon />
  </MenuItem>
));

const DropMenu: React.FC<OwnProps> = ({
  header,
  footer,
  items,
  anchorEl,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <Menu
      data-testid={'autosky-dropmenu'}
      classes={{
        paper: classes.menu,
        list: classes.menuList,
      }}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      keepMounted
      elevation={1}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {header && (
        <>
          <ListItem>
            <ListItemText
              classes={{
                primary: classes.headerText,
              }}
              primary={header.title}
            />
            {header?.icon && (
              <ListItemIcon
                classes={{
                  root: classes.headerIcon,
                }}
              >
                {header.icon}
              </ListItemIcon>
            )}
          </ListItem>

          <Divider />
        </>
      )}

      {items}

      {footer && (
        <ListItem
          className={classes.footer}
          button
          to={footer.href}
          component={Link}
          disabled
        >
          {footer?.icon && <ListItemIcon>{footer.icon}</ListItemIcon>}
          <ListItemText
            classes={{ primary: classes.footerText }}
            primary={footer.title}
          />
        </ListItem>
      )}
    </Menu>
  );
};

export default DropMenu;
